import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import AreaChart from "../../../components/Graph/AreaChart";
import { catchAsync, checkResponse } from "../../../utilities/utilities";
import { GET_EARNING_REPORT } from "../../../services/ApiCalls";
import Loader from "../../../components/Common/Loader";

const Earnings = () => {
  const [data, setData] = useState();
  const [loader, setLoader] = useState(false);

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await GET_EARNING_REPORT();
    checkResponse({ res, setData, setLoader });
  }, setLoader);

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {loader && <Loader />}
      <section className="earningSec py-3 position-relative">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                Earning
              </h4>
            </Col>
            <Col lg="8" className="my-2">
              <div className="cardCstm p-3 border h-100 rounded">
                <div className="cardHead m-0 pb-2 d-flex align-items-center justify-content-between gap-10">
                  <h6 className="m-0 fw-sbold themeClr">Revenue</h6>
                  <p class="m-0 fw-sbold text-muted">Last 7 days</p>
                </div>
                <div className="cardBody">
                  <AreaChart dashboardData={data} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Earnings;
